import React, { useEffect, useState } from 'react';
import './ConfigurePopup.scss'; // Import the styling
import { fetchFctlHw, postPipeSequence } from '../../APICalls/GetRequests';
import Cookies from 'js-cookie';
import Popup from "../../UI/Popup";

const ConfigurePopup = ({ isVisible, field, handleClosePopup, setPipes }) => {
  const [fctlList, setFctlList] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [pipeArray, setPipeArray] = useState([]);
  const [selectedLocalId, setSelectedLocalId] = useState("");

  useEffect(() => {
    fetchFctlHw(Cookies.get("session_key"))
      .then((data) => {
        setFctlList(data);
        const matchingObject = data.find((item) => item.id == field.hwid);
        if (matchingObject) {
          setSelectedLocalId(matchingObject.localid);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleAddString = (event) => {
    event.preventDefault();
    if (inputValue.trim()) {
      setPipeArray([...pipeArray, inputValue.trim()]);
      setInputValue(""); // Clear the input field
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission
    const body = { serials: pipeArray }; // ✅ only serials now
    postPipeSequence(field.id, body, Cookies.get('session_key')) // ✅ send field.id in URI
      .then(response => {
        console.log('Sequence submitted successfully', response);

        if (response.status === 'processing') {
          alert('Sequencing is processing. Please wait...');
        } else if (response.status === 'success') {
          alert('Pipes sequenced successfully!');
          if (setPipes) setPipes(pipeArray); // optionally update parent state
          handleClosePopup();
        }
      })
      .catch(error => {
        console.error('Error submitting sequence', error);
        alert('Failed to submit sequence. Please try again.');
      });
  };

  return (
    <Popup
      isVisible={isVisible}
      headerText={`Sequence ${field.name}`}
      handleSave={handleSubmit}
      handleClose={handleClosePopup}
      saveButtonText="Submit"
      popupContent={
        <>
          <p>Start at one end of the irrigation pipeline</p>
          <form onSubmit={handleAddString}>
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder="Enter string"
            />
            <button type="submit">Add</button>
          </form>
          <ul>
            {pipeArray.map((str, index) => (
              <li key={index}>{str}</li>
            ))}
          </ul>
        </>
      }
    />
  );
};

export default ConfigurePopup;
